import { Project } from "./types";

export const projects: Project[] = [
  {
    name: "Pundit Auto-Mobile Nigeria",
    image: "/images/Pundit.jpg",
    role: "Frontend engineering",
    impact: "Company website for a Nigerian auto repair business",
    description:
      "A responsive company website that presents services, supported vehicle brands, and customer contact paths for an automobile repair business.",
    languages: ["React", "TypeScript", "Tailwind CSS"],
    github: "https://github.com/Ogaga01/Pundit_Automobile_Nigeria",
    live: "https://punditautomobilenigeria.netlify.app/",
  },
  {
    name: "Elite Travelers",
    image: "/images/Elite-Travelers.jpg",
    role: "Full-stack development",
    impact: "Reservation experience for private jets and luxury cars",
    description:
      "A travel booking experience where users can browse private planes and luxury cars, then reserve premium travel options for their trips.",
    languages: ["React", "TypeScript", "Ruby", "Rails", "PostgreSQL"],
    github: "https://github.com/Ogaga01/Elite-Traveler-Frontend",
    live: "https://elite-travelers.netlify.app/",
  },
  {
    name: "Friendly Budget",
    image: "/images/Friendly-Budget.jpg",
    role: "Backend and UI development",
    impact: "Budget tracking with category-level spending visibility",
    description:
      "A mobile web application where users can manage transactions by category and understand where their money is going.",
    languages: ["Ruby", "Rails", "PostgreSQL"],
    github: "https://github.com/Ogaga01/Budget-App",
    live: "https://friendly-budget.onrender.com",
  },
  {
    name: "Amazon Clone",
    image: "/images/Amazon-Clone.jpg",
    role: "Frontend engineering",
    impact: "Shopping flow with cart and user detail interactions",
    description:
      "A commerce interface inspired by Amazon, with product browsing, cart interactions, and user detail editing.",
    languages: ["React", "Node.js", "Redux", "TypeScript"],
    github: "https://github.com/Ogaga01/Amazon-App-Clone-Frontend",
    live: "https://scintillating-pixie-59f96e.netlify.app",
  },
  {
    name: "Countries Info",
    image: "/images/countries-info.jpg",
    role: "Frontend engineering",
    impact: "Live country data with browsable detail screens",
    description:
      "An API-driven web application that displays country data and lets users inspect details for a selected country.",
    languages: ["React", "Countries API", "Redux"],
    github: "https://github.com/Ogaga01/Countries-Info-App",
    live: "https://candid-sfogliatella-37d461.netlify.app/",
  },
  {
    name: "Space Travelers Hub",
    image: "/images/space-traveler.jpg",
    role: "Frontend engineering",
    impact: "SpaceX data integration with mission booking interactions",
    description:
      "A SpaceX API application where users can reserve rockets and join space missions through a clean booking interface.",
    languages: ["React", "Redux", "SpaceX API"],
    github: "https://github.com/Ogaga01/space-travelers-hub",
    live: "https://regal-genie-823357.netlify.app/",
  },
  {
    name: "Awesome Books",
    image: "/images/awesome-books.jpg",
    role: "Frontend development",
    impact: "Simple library management experience",
    description:
      "A browser-based library app where users can add, remove, and review books in a small collection.",
    languages: ["Webpack", "JavaScript"],
    github: "https://github.com/Ogaga01/My-Awesome-Books",
    live: "https://ogaga01.github.io/My-Awesome-Books/",
  },
  {
    name: "Leaders Board",
    image: "/images/leaders-board.jpg",
    role: "Frontend development",
    impact: "Score submission and persistence through an external API",
    description:
      "A leaderboard website that displays player scores, accepts new submissions, and persists data through an external API.",
    languages: ["Webpack", "JavaScript", "Leaderboard API"],
    github: "https://github.com/Ogaga01/Microverse-Leadersboard-API",
    live: "https://legendary-kashata-ceb034.netlify.app",
  },
  {
    name: "Roll The Dice Game",
    image: "/images/roll-the-dice.jpg",
    role: "Game UI development",
    impact: "Interactive browser game with score tracking",
    description:
      "A two-player browser game where players roll dice, bank points, and race to reach 100 points.",
    languages: ["HTML", "CSS", "JavaScript"],
    github: "https://github.com/Ogaga01/Roll-The-Dice-Game",
    live: "https://ogaga01.github.io/Roll-The-Dice-Game",
  },
  {
    name: "Bookstore",
    image: "/images/bookstore.jpg",
    role: "Frontend engineering",
    impact: "Book collection management with Redux state",
    description:
      "A React bookstore application where users can add, remove, and manage books in a Redux-powered interface.",
    languages: ["React", "Firebase", "Redux"],
    github: "https://github.com/Ogaga01/Bookstore-React",
    live: "https://amazing-pixie-f339d9.netlify.app",
  },
];
